// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    /* button color STARTS */
    --primary-button-color: #1E88E5;
    --primary-button-light-color: #5281cf;
    --primary-button-border-color: #295192;
    --primary-button-text-color: #FFFFFF;
    --cancel-button-color: #546E7A;
    --secondary-button-color:#656ED0;
    --secondary-button-light-color: #848bd9;
    --approve-button-color:#00A945;
    --decline-button-color:#F76739;
    --download-button-color:#00A945;
    --download-button-light-color:#00A945;
    /* button color ENDS */

    /* font color STARTS */
    --primary-font-color: #000000;
    --secondary-font-color: #747474;
    --highlight-font-color: #1E88E5;
    --success-font-color: #40cb88;
    --alert-font-color: #e22121;
    /* font color ENDS */
}`, "",{"version":3,"sources":["webpack://./src/stylesheets/zentrades-theme.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,qCAAqC;IACrC,sCAAsC;IACtC,oCAAoC;IACpC,8BAA8B;IAC9B,gCAAgC;IAChC,uCAAuC;IACvC,8BAA8B;IAC9B,8BAA8B;IAC9B,+BAA+B;IAC/B,qCAAqC;IACrC,sBAAsB;;IAEtB,sBAAsB;IACtB,6BAA6B;IAC7B,+BAA+B;IAC/B,+BAA+B;IAC/B,6BAA6B;IAC7B,2BAA2B;IAC3B,oBAAoB;AACxB","sourcesContent":[":root{\n    /* button color STARTS */\n    --primary-button-color: #1E88E5;\n    --primary-button-light-color: #5281cf;\n    --primary-button-border-color: #295192;\n    --primary-button-text-color: #FFFFFF;\n    --cancel-button-color: #546E7A;\n    --secondary-button-color:#656ED0;\n    --secondary-button-light-color: #848bd9;\n    --approve-button-color:#00A945;\n    --decline-button-color:#F76739;\n    --download-button-color:#00A945;\n    --download-button-light-color:#00A945;\n    /* button color ENDS */\n\n    /* font color STARTS */\n    --primary-font-color: #000000;\n    --secondary-font-color: #747474;\n    --highlight-font-color: #1E88E5;\n    --success-font-color: #40cb88;\n    --alert-font-color: #e22121;\n    /* font color ENDS */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
